export default "./images/EN40.jpg";